type AppBootstrapSplashProps = {
  message: string;
  state?: 'loading' | 'error';
  title?: string;
  actionLabel?: string;
  onAction?: () => void;
};

export function AppBootstrapSplash({
  message,
  state = 'loading',
  title = state === 'error' ? 'We could not secure your session' : 'Loading Dream Team',
  actionLabel,
  onAction,
}: AppBootstrapSplashProps) {
  return (
    <div
      className="min-h-screen bg-[linear-gradient(180deg,#f5f5ff_0%,#ffffff_42%,#eef6ff_100%)]"
      data-auth-bootstrap={state}
      role={state === 'error' ? 'alert' : 'status'}
      aria-live={state === 'error' ? 'assertive' : 'polite'}
    >
      <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center gap-5 px-6 text-center">
        <div
          className={`h-14 w-14 rounded-full bg-[rgba(30,115,209,0.14)] ${state === 'loading' ? 'animate-pulse' : ''}`}
        />
        <div className="space-y-2">
          <p className="font-slab text-[28px] font-bold tracking-[-0.02em] text-[--color-blackblue-100]">
            {title}
          </p>
          <p className="font-primary text-[15px] leading-[22px] text-[rgba(32,29,74,0.72)]">
            {message}
          </p>
        </div>
        {actionLabel && onAction ? (
          <button
            type="button"
            onClick={onAction}
            className="rounded-full bg-[--color-blackblue-100] px-6 py-3 font-primary text-[15px] font-semibold text-white"
          >
            {actionLabel}
          </button>
        ) : null}
      </div>
    </div>
  );
}
